import React from 'react';

const ZERO_WIDTH_SPACE = <span>&#8203;</span>;

export const breakTextIntoLines = ({ text, lineBreak, lineClass, lineCSS }) =>
  text.split(lineBreak).map((line, key) => (
    // eslint-disable-next-line react/no-array-index-key
    <span className={lineClass} css={lineCSS} key={`line-${key}`}>
      {line || ZERO_WIDTH_SPACE}
    </span>
  ));

export const formatJSON = ({ text, indent }) =>
  text ? JSON.stringify(JSON.parse(text), null, indent) : '';
